import { z } from "zod";

export const RegisterPushNotificationsDeviceInputSchema = z.object({
	deviceToken: z.string(),
});

export type RegisterPushNotificationsDeviceInputType = z.infer<
	typeof RegisterPushNotificationsDeviceInputSchema
>;
